module.exports = __webpack_public_path__ + "img/meat.71e7fd27.svg";